import { z } from 'zod';

export const MoneySchema = z.object({
  amountMinor: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER),
  currency: z.string().regex(/^[A-Z]{3}$/),
  fractionDigits: z.number().int().min(0).max(4),
});
export type Money = z.infer<typeof MoneySchema>;

/** Whole-rouble money value. The storefront shows prices without kopecks. */
export function rub(amount: number): Money {
  return { amountMinor: Math.round(amount), currency: 'RUB', fractionDigits: 0 };
}

/** Major units (roubles) of a money value. */
export function toMajor(money: Money): number {
  return money.amountMinor / 10 ** money.fractionDigits;
}
